module.exports = __webpack_public_path__ + "a3bda85d4c37d23cff8a1755e61923db.jpg";